// Product brief for New York Life Asset Flex. See cmTwo.ts for the format intent.

export const nylAssetFlexBrief = `**NYL Asset Flex** — reimbursement hybrid life with an LTC rider.

Pool model — two pools, drawn in order:
- **Acceleration** is the \`base_pool\`, drawn FIRST.
- **Extension of Benefits (EOB)** is the \`eob\` column, drawn only after the
  Acceleration pool is exhausted.
- Both pools inflate on the **same ACIO rate**, compounding at the policy
  anniversary (\`base_pool_inflation\` / \`eob_pool_inflation\` in the header — they
  match on this product). The monthly cap inflates on that same ACIO rate.
- At-issue pools prefer Monthly Benefit × printed duration months when the
  duration fields are present. Printed ACIO dollar pools can be forward-inflated,
  so duration-derived dollars are the trustworthy at-issue base; legacy policies
  without duration fields fall back to stored dollar pools.

Payout model — **reimbursement only**:
- Pays min(eligible cost, pro-rated monthly cap), drawing Acceleration then EOB.
  Care cost above the cap is out-of-pocket; there is no cash-indemnity election,
  so \`payout\` never exceeds the month's care cost and indemnity surplus is $0.

Death benefit:
- Flat Face Amount, depleted **dollar-for-dollar by Acceleration drawdown**,
  floored at the Residual DB (10% of initial Face on the mapped illustration).
  EOB drawdown does NOT reduce it, and ACIO does not increase the Face. Remaining
  DB at the horizon is a non-LTC return.

Elimination period:
- **No retroactive WP lump.** Elimination-period days are out-of-pocket
  (\`in-wp\` rows).

Things to eyeball:
- Acceleration depletes before any EOB drawdown.
- Both pool ceilings grow on the same rate (equal \`base_pool\`/\`eob\` inflation).
- Death benefit falls only with Acceleration drawdown, never EOB drawdown.
- Indemnity surplus is $0 — this is a pure reimbursement product.
`;
